import tippy from "tippy.js";

export const TippyHook = {
  mounted() {
    // console.log("mount tippy")
    this.tippy = tippy(this.el, {
      trigger: this.el.dataset.tippytrigger,
      content: this.el.dataset.tippycontent,
      allowHTML: true,
    });
  },

  updated() {
    console.log("updating tippy");
    this.tippy.setProps({ content: this.el.dataset.tippycontent });
  },

  destroyed() {
    console.log("destryoing tippy");
    this.tippy.destroy();
  },
};

export const CopyToClipboardHook = {
  mounted() {
    console.log("mount CopyToClipboard");
    this.el.addEventListener("click", (e) => {
      // let match = this.el.value.replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/)
      // if(match) {
      //   this.el.value = `${match[1]}-${match[2]}-${match[3]}`
      // }
      console.log("CopyToClipboard click", this.el.dataset.clipboardcontent);
      // var copyText = document.getElementById("content").value;
      navigator.clipboard
        .writeText(this.el.dataset.clipboardcontent)
        .then(() => {
          if (this.el.dataset.alerttext) {
            // Alert the user that the action took place.
            // Nobody likes hidden stuff being done under the hood!
            alert(this.el.dataset.alerttext);
          }
        });
    });
    // this.tippy = tippy(this.el, { trigger: this.el.dataset.tippytrigger, content: this.el.dataset.tippycontent, allowHTML: true });
  },

  updated() {
    console.log("updating CopyToClipboard");
    // this.tippy.setProps({content: this.el.dataset.tippycontent})
  },

  destroyed() {
    console.log("destryoing CopyToClipboard");
    // this.tippy.destroy();
  },
};

// export const EasePickHook = {
//   mounted() {
//     console.log("mount EasePickHook");
//     this.setupElement(this.el);
//   },

//   updated() {
//     console.log("updating EasePickHook");
//     this.setupElement(this.el);
//   },

//   destroyed() {
//     console.log("destryoing EasePickHook");
//   },

//   setupElement(el) {
//     const picker = new easepick.create({
//       element: "#".concat(el.id),
//       css: [
//         "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
//       ],
//       zIndex: 10,
//       setup: (picker) => {
//         picker.on("select", (e) => {
//           const { view, date, target } = e.detail;
//           console.log("selected", view, date, target);
//           el.dispatchEvent(new Event("input", { bubbles: true }));
//         });
//       },
//     });

//     // this.picker = picker;
//     window.picker = picker;

//     el.addEventListener("click", (e) => {
//       console.log("showwwing");
//       picker.show();

//       // e.preventDefault();
//     });
//   },
// };

export const WaveSurferHook = {
  mounted() {
    console.log("mount WaveSurferHook");
    let presigned_url = this.el.dataset.presignedurl;
    console.log("presigned url", presigned_url);

    let cursorWidth = 2;
    if (this.el.dataset.displaycursor == "false") {
      cursorWidth = 0;
    }

    let wavesurfer = WaveSurfer.create({
      container: document.querySelector(this.el.dataset.wavesurfercontainer),

      scrollParent: false,
      minPxPerSec: 1,
      responsive: true,
      normalize: true,
      waveColor: "purple",
      progressColor: "purple",
      height: 50,
      barWidth: 1,
      //barRadius: 3,
      BarHeight: 1,
      barGap: null,
      cursorWidth: cursorWidth,
    });

    this.wavesurfer = wavesurfer;
    let data = JSON.parse(this.el.dataset.peakdata);

    // console.log(
    //   "this.el.dataset.displaycursor is ",
    //   this.el.dataset.displaycursor
    // );
    // console.log("data is", data);
    // console.log("peakdata is", JSON.parse(this.el.dataset.peakdata));

    this.wavesurfer.load(presigned_url, data);

    this.wavesurfer.on("interaction", () => {
      // console.log("playing... ", this.wavesurfer);
      // this.wavesurfer.play();
    });

    // wavesurfer.on("finish", () => {
    //   wavesurfer.setTime(0);
    // });

    let playbutton = document.querySelector(this.el.dataset.playbutton);
    if (playbutton) {
      playbutton.addEventListener("click", () => {
        console.log("playbutton clicked");
        this.wavesurfer.play();
        document.querySelector(this.el.dataset.playbutton).style.display =
          "none";
        document.querySelector(this.el.dataset.pausebutton).style.display =
          "block";
      });
    }

    let pausebutton = document.querySelector(this.el.dataset.pausebutton);
    if (pausebutton) {
      pausebutton.addEventListener("click", () => {
        console.log("pausebutton clicked");
        this.wavesurfer.pause();
        document.querySelector(this.el.dataset.pausebutton).style.display =
          "none";
        document.querySelector(this.el.dataset.playbutton).style.display =
          "block";
      });
    }
  },

  updated() {
    console.log("updating WaveSurferHook");
  },

  destroyed() {
    console.log("destryoing WaveSurferHook");
    this.wavesurfer.destroy();
  },
};

export const StripeElementsHook = {
  mounted() {
    console.log("mount StripeElementsHook");
    const stripe = Stripe(this.el.dataset.stripepk);
    let elements = stripe.elements({
      clientSecret: this.el.dataset.intentsecret,
    });
    const paymentElementOptions = {
      layout: "tabs",
      billingDetails: { name: "auto" },
    };
    const paymentElement = elements.create("payment", paymentElementOptions);
    paymentElement.mount(this.el.dataset.paymentel);

    const addressElement = elements.create("address", { mode: "billing" });
    addressElement.mount(this.el.dataset.billingel);

    document
      .querySelector(this.el.dataset.formel)
      .addEventListener("submit", (e) => {
        e.preventDefault();

        console.log("submitting paymentintent");

        let submitButton = document.querySelector(
          "#" + this.el.id + ' ~ button[type="submit"]'
        );

        submitButton.disabled = true;

        stripe
          .confirmPayment({
            elements,
            confirmParams: {
              // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
              return_url: this.el.dataset.redirect,
            },
          })
          .then((result) => {
            console.log("paymentintent result", result);
            if (result.error) {
              console.log("paymentintent error", result.error);
              this.pushEvent("stripe-payment-error", {
                error: result.error,
              });

              submitButton.disabled = false;
            } else {
              console.log("paymentintent no error");
            }
          });
      });
  },

  updated() {
    console.log("updating StripeElementsHook");
  },

  destroyed() {
    console.log("destryoing StripeElementsHook");
  },
};

export const StripeElementsExistingCardHook = {
  mounted() {
    console.log("mount StripeElementsExistingCardHook");
    const stripe = Stripe(this.el.dataset.stripepk);

    document
      .querySelector(this.el.dataset.formel)
      .addEventListener("submit", (e) => {
        e.preventDefault();
        console.log("confirming existing paymentintent");

        let submitButton = document.querySelector(
          "#" + this.el.id + ' ~ button[type="submit"]'
        );
        submitButton.disabled = true;

        stripe
          .confirmCardPayment(this.el.dataset.intentsecret, {
            // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
            return_url: this.el.dataset.redirect,
          })
          .then((result) => {
            console.log("paymentintent result", result);
            if (result.error) {
              console.log("paymentintent error", result.error);
              this.pushEvent("stripe-payment-error", {
                error: result.error,
              });

              submitButton.disabled = false;
            } else {
              let url = new URL(this.el.dataset.redirect);
              url.searchParams.set("payment_intent", result.paymentIntent.id);
              console.log(
                "paymentintent no error - redirecting page to ",
                url.href
              );
              window.location.assign(url.href);
            }
          });
      });
  },
};
